<template>
  <el-button class="button" :style="cssProps" @click="onClick" :disabled="disabled"><slot></slot></el-button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    active: {
      default: false,
      type: Boolean
    },
    bgColor: {
      type: String
    },
    border: {
      type: String
    },
    color: {
      type: String
    },
    borderRadius: {
      type: String | Number
    },
    padding: {
      type: String | Number
    },
    fontSize: {
      type: String | Number
    },
    lineHeight: {
      type: String
    },
    fontWeight: {
      type: String | Number
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    cssProps() {
      return {
        '--color': this.color,
        '--fontSize': this.fontSize,
        '--bgColor': this.bgColor,
        '--border': this.border,
        '--margin': this.margin,
        '--padding': this.padding,
        '--borderRadius': this.borderRadius,
        '--lineHeight': this.lineHeight,
        '--fontWeight': this.fontWeight
      };
    }
  },
  methods: {
    onClick(...args) {
      this.$emit('click', ...args);
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  color: var(--color, #1e90ff);
  font-size: var(--fontSize, 14px);
  background-color: var(--bgColor, #fff);
  border: var(--border);
  margin: var(--margin);
  padding: var(--padding, 14px 53px);
  border-radius: var(--borderRadius, 34px);
  line-height: var(--lineHeight);
  font-weight: var(--fontWeight);
  font-family: NotoSansCJKsc-Medium;
  user-select: none;
  min-width: 120px;

  &:focus {
    background-color: var(--bgColor, #fff);
    color: var(--color, #1e90ff);
  }

  &:hover {
    background-color: var(--bgColor, #fff);
    color: var(--color, #1e90ff);
  }

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    padding: 25px;
  }
}
</style>
